import type { AdapterRow } from '../../unifiedcommerce/framework';

type Props = { adapters?: AdapterRow[] };

export function MarketplaceAdapterPanel({ adapters = [] }: Props) {
  return (
    <div className="space-y-2">
      {adapters.map((a) => (
        <div key={a.feature} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{a.feature}</p>
          <div className="shrink-0 text-right">
            <p className="text-sm font-semibold text-success-600">{a.coverage}%</p>
            <p className="text-xs text-slate-500">{a.status}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
